quosal.api.ciscoIntegration = {};

quosal.api.ciscoIntegration.authorize = function () {
    return quosal.api.call('Cisco.Authorize', {});
};

quosal.api.ciscoIntegration.removeAuthorization = function () {
    return quosal.api.call('Cisco.RemoveAuthorization', {});     
};